import React from 'react';
import DownloadClientEmails from '../Components/DownloadClientEmails';
import DownloadClientPlates from '../Components/DownloadClientPlates';
import DownloadTicketBySummonsNumber from '../Components/DownloadTicketBySummonsNumber';
import FoundTicketsListModal from '../Components/FoundTicketsListModal';
import TicketSearchByPlate from '../Components/TicketSearchByPlate';
import { withAuthenticationRequired } from '../providers/withAuthenticationRequired';
import DownloadIgnoredTickets from '../Components/DownloadIgnoredTickets';
import AddBulkIgnoreTickets from '../Components/AddBulkIgnoreTickets';
import TicketSummaryReportEmailDispatcher from '../Components/TicketSummaryReportEmailDispatcher';
import DownloadEligibleForTowingReport from '../Components/Reports/DownloadEligibleForTowingReport';
import DelinquentTicketsReportEmailDispatcher from '../Components/Reports/DelinquentTicketsReportEmailDispatcher';
import TicketsInJudgmentReport from '../Components/Reports/TicketsInJudgmentReport';
import RegistrationExport from '../Components/Reports/RegistrationExport';
import ReportBuilder from '../Components/ReportBuilder/ReportBuilder';
import { CreditReports } from '../Components/Credit';

function ReportsPage() {
  return (
    <div className="mt-5">
      <ReportBuilder />
      <hr />
      <CreditReports />
      <hr />
      <TicketSearchByPlate />
      <hr />
      <FoundTicketsListModal />
      <DownloadTicketBySummonsNumber />
      <hr />
      <DownloadClientEmails />
      <hr />
      <DownloadClientPlates />
      <hr />
      <DownloadIgnoredTickets />
      <hr />
      <TicketSummaryReportEmailDispatcher />
      <hr />
      <AddBulkIgnoreTickets />
      <hr />
      <DownloadEligibleForTowingReport />
      <hr />
      <DelinquentTicketsReportEmailDispatcher />
      <hr />
      <TicketsInJudgmentReport />
      <hr />
      <RegistrationExport />
    </div>
  );
}

export default withAuthenticationRequired(ReportsPage);
